import { HeadingText, BodyText } from '@unmind/design-system';
import { rem } from 'polished';
import styled, { css } from 'styled-components';
import { Slack as SlackIcon, MSTeams as MSTeamsIcon } from '../../../icons';

export const Card = styled.div`
  display: grid;
  border: 1px solid ${props => props.theme.colors.border.secondary};
  border-radius: ${rem(32)};
  padding: ${rem(24)};
  grid-gap: ${rem(12)};
  background: ${props => props.theme.colors.background.card};
`;

const LogoStyling = ` 
  width: ${rem(32)};
  height: ${rem(32)};
  margin-bottom: ${rem(8)};
`;

export const SlackLogo = styled(SlackIcon)`
  ${LogoStyling}

  ${css`
    flex-shrink: 0;
  `}
`;

export const MSTeamsLogo = styled(MSTeamsIcon)`
  ${LogoStyling}
`;

export const IntegrationName = styled(HeadingText).attrs(({ theme }) => ({
  color: theme.colors.text.primary,
  sizes: [
    theme.typography.fontSizes.fontSize16,
    theme.typography.fontSizes.fontSize20,
    theme.typography.fontSizes.fontSize24,
  ],
  weight: theme.typography.fontWeights.medium,
}))``;

export const IntegrationHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const IntegrationBanner = styled(BodyText).attrs(({ theme }) => ({
  color: theme.colors.text.secondary,
  sizes: [theme.typography.fontSizes.fontSize12],
}))`
  text-align: right;
  max-height: 100px;
  overflow: scroll;
  text-wrap: balance;
`;

export const IntegrationDesc = styled(BodyText).attrs(({ theme }) => ({
  color: theme.colors.text.primary,
  sizes: [theme.typography.fontSizes.fontSize14],
}))`
  max-width: ${rem(374)};
  margin-bottom: ${rem(15)};
`;

export const IntegrationButtonText = styled(BodyText)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IntegrationActionsContainer = styled.div<{ isSlackUser: boolean }>`
  display: flex;
  justify-content: ${({ isSlackUser }) => (isSlackUser ? 'center' : 'start')};
  flex-flow: wrap;
  gap: ${rem(8)};

  /* @TODO: This is to center the contents of the button - we should fix this in the button component itself */
  a > span {
    display: flex;
    align-items: center;
  }
`;
